import { useEffect, useState } from 'react';
import { gpsService } from '@/services/gps';
import {
  buildEmbedUrl,
  hasDestination,
  type MapsDestination,
} from '@/lib/maps';

interface RouteMapPreviewProps {
  destination: MapsDestination;
}

/** In-app route preview (destination + current GPS when available). */
export function RouteMapPreview({ destination }: RouteMapPreviewProps) {
  const [src, setSrc] = useState(() => buildEmbedUrl(destination));

  useEffect(() => {
    if (!hasDestination(destination)) return;
    let cancelled = false;
    void gpsService.currentFix().then((fix) => {
      if (!cancelled) setSrc(buildEmbedUrl(destination, fix));
    });
    return () => {
      cancelled = true;
    };
  }, [destination]);

  if (!hasDestination(destination)) return null;

  return (
    <div className="aspect-[4/3] w-full overflow-hidden rounded-lg border border-brand-border bg-brand-surface">
      <iframe
        title="Route map"
        src={src}
        className="h-full w-full border-0"
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    </div>
  );
}
